import { Outlet } from "react-router-dom";

export const BrmLayout = () => {
  return (
    <>
      <Outlet />
    </>
  );
};
